import React, { Component } from 'react';
import { connect } from 'react-redux';

import { getCoreHttp, getReportsHttp } from 'actions/httpRequest';
import { REPORTS_NAMESPACE } from 'actions/typeConstants';
import QueueGrid from './queueGrid';
import Loading from 'presentational/Loading';

import { formatDateTimePicker } from 'utils/misc';

import { DateTimePicker } from '@material-ui/pickers';
import LinearProgress from '@material-ui/core/LinearProgress';
import Popover from '@material-ui/core/Popover';
import Button from '@material-ui/core/Button';
import Switch from '@material-ui/core/Switch';
import Tooltip from '@material-ui/core/Tooltip';

import { errorNotification } from 'actions/notifications';

const DATE_PRESETS = [
    { value: 'today', label: 'Today' },
    { value: 'yesterday', label: 'Yesterday' },
    { value: 'week', label: 'This Week' },
    { value: 'month', label: 'This Month' },
];

class QueueRecords extends Component {
    constructor(props) {
        super(props);
        this.state = {
            mediaQuery: false,
            reqQuery: null,
            startDate: null,
            endDate: null,
            timeInterval: 'today',
            search: '',
            displayQueueMemberEvents: false,
            filterQueues: [],
            acdQueues: [],
            acdSelected: false,
            openPopover: null,
            anchorEl: null,
            pendingTimeInterval: null,
            pendingStartDate: null,
            pendingEndDate: null,
        };
    }

    componentDidMount() {
        this.fetchQueueRecords();
        this.fetchConfigurations();
        const mq = window.matchMedia('(min-width: 800px)');
        this.setState({ mediaQuery: mq });
        mq.addListener(mediaQuery => this.setState({ mediaQuery }));
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps && nextProps.phoneNumbers) {
            const phonesWithACD = nextProps.phoneNumbers.filter(
                phone => !!phone.acd_queue_identifier
            );
            if (phonesWithACD.length > 0) {
                const acdQueueIdentifiers = [];
                phonesWithACD.forEach(phone => {
                    if (
                        acdQueueIdentifiers.indexOf(
                            phone.acd_queue_identifier
                        ) === -1
                    ) {
                        acdQueueIdentifiers.push(phone.acd_queue_identifier);
                    }
                });
                this.setState({ acdQueues: acdQueueIdentifiers });
            }
        }
        if (
            nextProps &&
            nextProps.queues &&
            nextProps.queues !== this.props.queues &&
            nextProps.dialedNumbers != this.props.dialedNumbers
        ) {
            this.setState({
                filterQueues: nextProps.queues.concat(nextProps.dialedNumbers),
            });
        }
    }

    buildReqQuery() {
        const dateTimes = this.state.timeInterval;
        const startDate = this.state.startDate;
        const endDate = this.state.endDate;
        let query = '';
        if (dateTimes == 'custom') {
            if (!startDate || !endDate) {
                return '';
            }
            if (moment(endDate).isBefore(moment(startDate))) {
                errorNotification({
                    message: 'End date must be after start date.',
                    id: 'queueReportsDateRange',
                });
                return '';
            }
            // Server appends its own time component to these params;
            // sending datetime produces "Double time specification".
            query += `&startdate=${moment(startDate).format('YYYY-MM-DD')}`;
            query += `&enddate=${moment(endDate).format('YYYY-MM-DD')}`;
        } else if (dateTimes && dateTimes.length > 0) {
            query += `&timeinterval=${dateTimes}`;
        }
        this.setState({ reqQuery: query });
        return query;
    }

    fetchQueueRecords() {
        const reqQuery = this.buildReqQuery();
        if (this.state.timeInterval === 'custom' && !reqQuery) {
            return;
        }
        const reqData = {
            reqAction: 'queuelogreport',
            reqQuery,
        };
        this.props.getReportsHttp(reqData, 'queueRecords', REPORTS_NAMESPACE);
    }

    fetchConfigurations() {
        this.props.getCoreHttp({ reqAction: 'configurations' });
    }

    async searchRecords(term) {
        await this.setState({ search: term });
        this.filterData();
    }

    filterData() {
        const term = this.state.search;
        const displayQueueMemberEvents = this.state.displayQueueMemberEvents;
        const filterQueues = this.state.filterQueues;
        const data = this.props.queueRecords;
        const filteredData = [];
        if (!data || !data.length) {
            return [];
        }
        if (!term && !displayQueueMemberEvents) {
            const phoneNumberACD = [];
            this.state.acdQueues.forEach(acd => {
                if (filterQueues.includes(acd)) {
                    this.props.phoneNumbers.forEach(phone => {
                        if (phone.acd_queue_identifier === acd) {
                            if (
                                phoneNumberACD.indexOf(phone.phonenumber) === -1
                            ) {
                                phoneNumberACD.push(phone.phonenumber);
                            }
                        }
                    });
                }
            });
            data.map(queueCall => {
                const queueCallCopy = JSON.stringify(queueCall).toLowerCase();
                if (
                    !queueCallCopy.includes('addmember') &&
                    !queueCallCopy.includes('removemember') &&
                    filterQueues.includes(queueCall.queuename) &&
                    filterQueues.includes(queueCall.dialednumber) &&
                    phoneNumberACD.length === 0
                ) {
                    filteredData.push(queueCall);
                } else if (phoneNumberACD.length > 0) {
                    // Within the ACD subset, also honor queue + dialed
                    // filter selections so users can narrow further.
                    phoneNumberACD.forEach(phone => {
                        if (
                            queueCall.dialednumber === phone &&
                            filterQueues.includes(queueCall.queuename) &&
                            filterQueues.includes(queueCall.dialednumber)
                        ) {
                            filteredData.push(queueCall);
                        }
                    });
                }
            });
            return filteredData;
        }
        data.map(queueCall => {
            const queueCallCopy = JSON.stringify(queueCall).toLowerCase();
            if (
                displayQueueMemberEvents &&
                term.length &&
                queueCallCopy.includes(term.toLowerCase()) &&
                filterQueues.includes(queueCall.queuename)
            ) {
                filteredData.push(queueCall);
            } else if (
                (displayQueueMemberEvents &&
                    !term.length &&
                    filterQueues.includes(queueCall.queuename)) ||
                queueCall.memberEvent
            ) {
                if (!displayQueueMemberEvents && queueCall.memberEvent) {
                    return;
                }
                filteredData.push(queueCall);
            } else if (
                !displayQueueMemberEvents &&
                queueCallCopy.includes(term.toLowerCase()) &&
                !queueCall.memberEvent &&
                filterQueues.includes(queueCall.queuename)
            ) {
                filteredData.push(queueCall);
            }
        });
        return filteredData;
    }

    async queueMemeberEventsToggle() {
        await this.setState({
            displayQueueMemberEvents: !this.state.displayQueueMemberEvents,
        });
    }

    handleQueueFilterChange(kind, values) {
        // Queue + Dialed filters share filterQueues state; ACD toggles acdSelected.
        if (kind === 'acd') {
            const anyAcd = this.state.acdQueues.some(
                r => values.indexOf(r) >= 0
            );
            if (anyAcd && this.state.acdSelected) {
                this.setState({ filterQueues: values });
            } else if (anyAcd && !this.state.acdSelected) {
                this.setState({ filterQueues: values, acdSelected: true });
            } else if (this.state.acdSelected) {
                this.setState({ filterQueues: values, acdSelected: false });
            } else {
                this.setState({ filterQueues: values });
            }
        } else {
            this.setState({ filterQueues: values });
        }
    }

    // --- Popover open/close + Dates apply/cancel ---

    openPopover(kind, event) {
        const currentTarget = event && event.currentTarget;
        if (kind === 'dates') {
            this.setState({
                openPopover: 'dates',
                anchorEl: currentTarget,
                pendingTimeInterval: this.state.timeInterval,
                pendingStartDate: this.state.startDate,
                pendingEndDate: this.state.endDate,
            });
        } else {
            this.setState({ openPopover: kind, anchorEl: currentTarget });
        }
    }

    closePopover() {
        this.setState({
            openPopover: null,
            anchorEl: null,
            pendingTimeInterval: null,
            pendingStartDate: null,
            pendingEndDate: null,
        });
    }

    async selectDatePreset(preset) {
        if (preset === 'custom') {
            const start =
                this.state.pendingStartDate ||
                formatDateTimePicker(moment().startOf('day'));
            const end =
                this.state.pendingEndDate ||
                formatDateTimePicker(moment().endOf('day'));
            this.setState({
                pendingTimeInterval: 'custom',
                pendingStartDate: start,
                pendingEndDate: end,
            });
            return;
        }
        await this.setState({
            timeInterval: preset,
            startDate: null,
            endDate: null,
            openPopover: null,
            anchorEl: null,
            pendingTimeInterval: null,
            pendingStartDate: null,
            pendingEndDate: null,
        });
        this.fetchQueueRecords();
    }

    changePendingStart(date) {
        this.setState({ pendingStartDate: formatDateTimePicker(date) });
    }

    changePendingEnd(date) {
        this.setState({ pendingEndDate: formatDateTimePicker(date) });
    }

    async applyDatesPopover() {
        const {
            pendingTimeInterval,
            pendingStartDate,
            pendingEndDate,
        } = this.state;
        if (pendingTimeInterval === 'custom') {
            if (!pendingStartDate || !pendingEndDate) {
                errorNotification({
                    message: 'Pick both a start and end date.',
                    id: 'queueReportsDateRange',
                });
                return;
            }
            if (moment(pendingEndDate).isBefore(moment(pendingStartDate))) {
                errorNotification({
                    message: 'End date must be after start date.',
                    id: 'queueReportsDateRange',
                });
                return;
            }
        }
        await this.setState({
            timeInterval: pendingTimeInterval,
            startDate:
                pendingTimeInterval === 'custom' ? pendingStartDate : null,
            endDate: pendingTimeInterval === 'custom' ? pendingEndDate : null,
            openPopover: null,
            anchorEl: null,
            pendingTimeInterval: null,
            pendingStartDate: null,
            pendingEndDate: null,
        });
        this.fetchQueueRecords();
    }

    // --- Chip label summaries ---

    datesSummary() {
        const { timeInterval, startDate, endDate } = this.state;
        if (timeInterval !== 'custom') {
            const preset = DATE_PRESETS.find(p => p.value === timeInterval);
            return preset ? preset.label : 'Today';
        }
        if (!startDate || !endDate) {
            return 'Custom';
        }
        return `${moment(startDate).format(
            'MMM D, h:mm A'
        )} – ${moment(endDate).format('MMM D, h:mm A')}`;
    }

    namesSummary(pool) {
        if (!pool || !pool.length) {
            return 'None';
        }
        const selected = pool.filter(name =>
            this.state.filterQueues.includes(name)
        );
        if (!selected.length) {
            return 'None';
        }
        if (selected.length === pool.length) {
            return 'All';
        }
        if (selected.length === 1) {
            return selected[0];
        }
        if (selected.length === 2) {
            return `${selected[0]}, ${selected[1]}`;
        }
        return `${selected[0]}, ${selected[1]}, +${selected.length - 2}`;
    }

    acdSummary() {
        const pool = this.state.acdQueues;
        if (!pool || !pool.length) {
            return 'Any';
        }
        const selected = pool.filter(name =>
            this.state.filterQueues.includes(name)
        );
        if (!selected.length) {
            return 'Any';
        }
        if (selected.length === 1) {
            return selected[0];
        }
        return `${selected.length} selected`;
    }

    renderChip(kind, label, value, opts = {}) {
        const isOpen = this.state.openPopover === kind;
        const chipStyle = {
            ...style.chip,
            ...(isOpen ? style.chipActive : {}),
            ...(opts.disabled ? style.chipDisabled : {}),
        };
        const dimmed = opts.disabled ? { color: 'rgba(0,0,0,0.38)' } : {};
        const button = (
            <button
                type="button"
                style={chipStyle}
                onClick={
                    opts.disabled
                        ? undefined
                        : e => this.openPopover(kind, e)
                }
                disabled={opts.disabled}
            >
                <span style={{ ...style.chipLabel, ...dimmed }}>{label}</span>
                <span style={{ ...style.chipValue, ...dimmed }}>{value}</span>
                <span style={{ ...style.chipCaret, ...dimmed }}>▾</span>
            </button>
        );
        if (opts.disabled && opts.tooltip) {
            // Disabled <button> swallows mouse events, so wrap in <span>
            // to let MUI Tooltip anchor its listeners.
            return (
                <Tooltip title={opts.tooltip} placement="bottom">
                    <span style={style.chipTooltipWrap}>{button}</span>
                </Tooltip>
            );
        }
        return button;
    }

    renderDatesPopover() {
        const {
            openPopover,
            anchorEl,
            pendingTimeInterval,
            pendingStartDate,
            pendingEndDate,
        } = this.state;
        const showCustom = pendingTimeInterval === 'custom';
        const customStart = pendingStartDate
            ? moment(pendingStartDate)
            : moment().startOf('day');
        const customEnd = pendingEndDate
            ? moment(pendingEndDate)
            : moment().endOf('day');
        return (
            <Popover
                open={openPopover === 'dates'}
                anchorEl={anchorEl}
                onClose={() => this.closePopover()}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                transformOrigin={{ vertical: 'top', horizontal: 'left' }}
            >
                <div style={style.datesPopover}>
                    <div style={style.datesPresetColumn}>
                        {DATE_PRESETS.map(p => {
                            const active = pendingTimeInterval === p.value;
                            return (
                                <div
                                    key={p.value}
                                    style={{
                                        ...style.datesPresetItem,
                                        ...(active
                                            ? style.datesPresetItemActive
                                            : {}),
                                    }}
                                    onClick={() =>
                                        this.selectDatePreset(p.value)
                                    }
                                >
                                    {p.label}
                                </div>
                            );
                        })}
                        <div
                            style={{
                                ...style.datesPresetItem,
                                ...(showCustom
                                    ? style.datesPresetItemActive
                                    : {}),
                            }}
                            onClick={() => this.selectDatePreset('custom')}
                        >
                            Custom
                        </div>
                    </div>
                    {showCustom && (
                        <div style={style.datesCustomColumn}>
                            <div style={style.datesFieldLabel}>Start</div>
                            <DateTimePicker
                                ampm
                                autoOk
                                value={customStart}
                                format="MMM DD, YYYY hh:mm A"
                                onChange={d => this.changePendingStart(d)}
                                maxDate={moment().endOf('day')}
                            />
                            <div
                                style={{
                                    ...style.datesFieldLabel,
                                    marginTop: '16px',
                                }}
                            >
                                End
                            </div>
                            <DateTimePicker
                                ampm
                                autoOk
                                value={customEnd}
                                format="MMM DD, YYYY hh:mm A"
                                onChange={d => this.changePendingEnd(d)}
                                maxDate={moment().endOf('day')}
                                minDate={
                                    pendingStartDate
                                        ? moment(pendingStartDate).startOf(
                                              'day'
                                          )
                                        : undefined
                                }
                            />
                            <div style={style.datesActions}>
                                <Button
                                    onClick={() => this.closePopover()}
                                    style={style.cancelButton}
                                >
                                    Cancel
                                </Button>
                                <Button
                                    onClick={() => this.applyDatesPopover()}
                                    variant="contained"
                                    color="primary"
                                    style={style.applyButton}
                                >
                                    Apply
                                </Button>
                            </div>
                        </div>
                    )}
                </div>
            </Popover>
        );
    }

    toggleMultiSelect(kind, name) {
        const current = this.state.filterQueues;
        const next = current.includes(name)
            ? current.filter(n => n !== name)
            : [...current, name];
        this.handleQueueFilterChange(kind, next);
    }

    renderMultiSelectPopover(kind, names) {
        const list = names || [];
        return (
            <Popover
                open={this.state.openPopover === kind}
                anchorEl={this.state.anchorEl}
                onClose={() => this.closePopover()}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                transformOrigin={{ vertical: 'top', horizontal: 'left' }}
            >
                <div style={style.multiSelectPopover}>
                    {list.map(name => {
                        const selected = this.state.filterQueues.includes(
                            name
                        );
                        return (
                            <div
                                key={name}
                                onClick={() =>
                                    this.toggleMultiSelect(kind, name)
                                }
                                style={{
                                    ...style.multiSelectItem,
                                    ...(selected
                                        ? style.multiSelectItemActive
                                        : {}),
                                }}
                            >
                                <span style={style.multiSelectCheck}>
                                    {selected ? '✓' : ''}
                                </span>
                                <span>{name}</span>
                            </div>
                        );
                    })}
                </div>
            </Popover>
        );
    }

    render() {
        const { queueRecords, queues, pending } = this.props;
        let { acdQueues } = this.state;
        if (!queueRecords || !queues) {
            return <Loading />;
        }
        const gridData = pending ? [] : this.filterData();
        acdQueues.sort((a, b) =>
            a.toLowerCase() > b.toLowerCase() ? 1 : -1
        );
        // acdLock no longer disables Queue / Dialed chips — those
        // selections now compose with the ACD filter inside filterData.
        // Emptiness is only meaningful once the relevant fetch has
        // completed. The reducer defaults data / queues / dialedNumbers
        // to [] and acdQueues starts as [] before phonenumber config
        // arrives, so without a load gate the initial render would
        // disable all filter chips before any request finishes.
        const recordsLoaded = !pending;
        // Strict !== so undefined counts as loaded. A tenant whose
        // configurations response omits the phonenumbers field returns
        // undefined here; that still means "no ACD phones", not "still
        // loading". Only literal null (mapStateToProps' pre-fetch
        // default) blocks the chip from resolving.
        const configLoaded = this.props.phoneNumbers !== null;

        const rangeEmpty = recordsLoaded && !queueRecords.length;
        // queues + dialedNumbers are extracted per-fetch from the
        // returned records, so an empty pool is always a range issue,
        // never a tenant-config one.
        const queueMissing =
            recordsLoaded &&
            (rangeEmpty ||
                !this.props.queues ||
                !this.props.queues.length);
        const dialedMissing =
            recordsLoaded &&
            (rangeEmpty ||
                !this.props.dialedNumbers ||
                !this.props.dialedNumbers.length);
        // acdQueues comes from all-time phonenumber config, so an empty
        // pool means the tenant has none configured (independent of the
        // date range) — but only claim that once configurations loaded.
        const acdUnconfigured =
            configLoaded && (!acdQueues || !acdQueues.length);

        const rangeTip = entity =>
            `No ${entity} exist for the selected date range`;

        const queueDisabled = queueMissing;
        const queueTip = queueMissing ? rangeTip('queues') : null;

        const dialedDisabled = dialedMissing;
        const dialedTip = dialedMissing
            ? rangeTip('dialed numbers')
            : null;

        const acdDisabled = rangeEmpty || acdUnconfigured;
        const acdTip = acdUnconfigured
            ? 'No ACD IDs are configured'
            : rangeEmpty
                ? rangeTip('ACD IDs')
                : null;

        return (
            <div style={style.wrapper}>
                <div style={style.chipBar}>
                    {this.renderChip('dates', 'Dates', this.datesSummary())}
                    {this.renderChip(
                        'queue',
                        'Queue',
                        this.namesSummary(this.props.queues),
                        { disabled: queueDisabled, tooltip: queueTip }
                    )}
                    {this.renderChip(
                        'dialed',
                        'Dialed',
                        this.namesSummary(this.props.dialedNumbers),
                        { disabled: dialedDisabled, tooltip: dialedTip }
                    )}
                    {this.renderChip(
                        'acd',
                        'ACD ID',
                        acdUnconfigured ? 'Not in use' : this.acdSummary(),
                        { disabled: acdDisabled, tooltip: acdTip }
                    )}
                    <label style={style.togglePill}>
                        <span style={style.chipLabel}>
                            Queue Member Events
                        </span>
                        <Switch
                            size="small"
                            color="primary"
                            checked={this.state.displayQueueMemberEvents}
                            onChange={() => this.queueMemeberEventsToggle()}
                        />
                    </label>
                    <div style={style.searchPill}>
                        <span style={style.searchIcon}>⌕</span>
                        <input
                            type="text"
                            placeholder="Search records"
                            value={this.state.search}
                            onChange={e =>
                                this.searchRecords(e.target.value)
                            }
                            style={style.searchInput}
                        />
                    </div>
                </div>

                {this.renderDatesPopover()}
                {this.renderMultiSelectPopover('queue', this.props.queues)}
                {this.renderMultiSelectPopover(
                    'dialed',
                    this.props.dialedNumbers
                )}
                {this.renderMultiSelectPopover('acd', acdQueues)}

                {pending && (
                    <LinearProgress style={style.loadingIndicator} />
                )}
                <QueueGrid data={gridData} pending={this.props.pending} />
            </div>
        );
    }
}

const bindActions = dispatch => ({
    getCoreHttp: (reqData, storeKey) =>
        dispatch(getCoreHttp(reqData, storeKey)),
    getReportsHttp: (reqData, storeKey, nameSpace) =>
        dispatch(getReportsHttp(reqData, storeKey, nameSpace)),
});

const mapStateToProps = state => ({
    queueRecords:
        state.queueRecords && state.queueRecords.data
            ? state.queueRecords.data
            : null,
    pending: state.queueRecords.pending ? state.queueRecords.pending : false,
    queues:
        state.queueRecords && state.queueRecords.queues
            ? state.queueRecords.queues
            : null,
    dialedNumbers: state.queueRecords.dialedNumbers
        ? state.queueRecords.dialedNumbers
        : null,
    phoneNumbers:
        state.configurations && state.configurations.data
            ? state.configurations.data.phonenumbers
            : null,
});

const style = {
    wrapper: {
        marginTop: '-20px',
        minHeight: '97vh',
        background: 'linear-gradient(0deg, #0F4E8B 50%, #EFEFEF 50%)',
        alignItems: 'center',
    },
    chipBar: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: '8px',
        padding: '12px 16px',
    },
    chip: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: '6px',
        padding: '6px 14px',
        borderRadius: '999px',
        background: '#fff',
        border: '1px solid rgba(0,0,0,0.15)',
        boxShadow: '0 1px 2px rgba(0,0,0,0.04)',
        fontSize: '13px',
        cursor: 'pointer',
        color: 'rgba(0,0,0,0.87)',
        outline: 'none',
        lineHeight: 1.4,
        whiteSpace: 'nowrap',
    },
    chipActive: {
        borderColor: '#0F4E8B',
        boxShadow: '0 0 0 2px rgba(15,78,139,0.15)',
    },
    chipDisabled: {
        background: '#f0f0f0',
        borderColor: 'rgba(0,0,0,0.08)',
        boxShadow: 'none',
        color: 'rgba(0,0,0,0.38)',
        cursor: 'not-allowed',
    },
    chipLabel: {
        fontWeight: 600,
        color: 'rgba(0,0,0,0.6)',
    },
    chipValue: {
        maxWidth: '220px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    chipCaret: {
        marginLeft: '2px',
        fontSize: '11px',
        color: 'rgba(0,0,0,0.54)',
    },
    chipTooltipWrap: {
        display: 'inline-flex',
    },
    togglePill: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: '4px',
        padding: '2px 6px 2px 14px',
        borderRadius: '999px',
        background: '#fff',
        border: '1px solid rgba(0,0,0,0.15)',
        boxShadow: '0 1px 2px rgba(0,0,0,0.04)',
        fontSize: '13px',
        lineHeight: 1.4,
        cursor: 'pointer',
    },
    searchPill: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: '6px',
        padding: '6px 14px',
        borderRadius: '999px',
        background: '#fff',
        border: '1px solid rgba(0,0,0,0.15)',
        boxShadow: '0 1px 2px rgba(0,0,0,0.04)',
        fontSize: '13px',
        lineHeight: 1.4,
        width: '180px',
    },
    searchIcon: {
        fontSize: '15px',
        color: 'rgba(0,0,0,0.54)',
    },
    searchInput: {
        border: 'none',
        outline: 'none',
        background: 'transparent',
        fontSize: '13px',
        color: 'rgba(0,0,0,0.87)',
        flex: 1,
        minWidth: 0,
        padding: 0,
        fontFamily: 'inherit',
    },
    datesPopover: {
        display: 'flex',
        minWidth: '260px',
    },
    datesPresetColumn: {
        display: 'flex',
        flexDirection: 'column',
        padding: '8px 0',
        borderRight: '1px solid rgba(0,0,0,0.08)',
        minWidth: '140px',
    },
    datesPresetItem: {
        padding: '10px 20px',
        cursor: 'pointer',
        fontSize: '14px',
        color: 'rgba(0,0,0,0.87)',
    },
    datesPresetItemActive: {
        background: 'rgba(15,78,139,0.08)',
        color: '#0F4E8B',
        fontWeight: 600,
    },
    datesCustomColumn: {
        padding: '16px 24px',
        minWidth: '260px',
        display: 'flex',
        flexDirection: 'column',
    },
    datesFieldLabel: {
        fontSize: '12px',
        color: 'rgba(0,0,0,0.54)',
        marginBottom: '4px',
    },
    datesActions: {
        marginTop: '20px',
        display: 'flex',
        justifyContent: 'flex-end',
        gap: '8px',
    },
    cancelButton: {
        color: 'rgba(0,0,0,0.6)',
    },
    applyButton: {
        background: '#0F4E8B',
    },
    multiSelectPopover: {
        padding: '8px 0',
        minWidth: '260px',
        maxHeight: '360px',
        overflowY: 'auto',
    },
    multiSelectItem: {
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        padding: '8px 20px',
        cursor: 'pointer',
        fontSize: '14px',
        color: 'rgba(0,0,0,0.87)',
        userSelect: 'none',
    },
    multiSelectItemActive: {
        color: '#0F4E8B',
        background: 'rgba(15,78,139,0.06)',
        fontWeight: 600,
    },
    multiSelectCheck: {
        display: 'inline-block',
        width: '14px',
        textAlign: 'center',
        color: '#0F4E8B',
        fontSize: '14px',
    },
    loadingIndicator: {
        height: 8,
    },
};

export default connect(mapStateToProps, bindActions)(QueueRecords);
